module.exports = __webpack_public_path__ + "images/ydlpk10.c607.png";